import React from 'react';
import { Box, Typography } from '@mui/material';
import { radius } from '../../theme';

// One shared "list item" row (food/friend/award/setting row): a leading
// icon/avatar, title+subtitle, and a trailing element. `variant="card"`
// renders as its own bordered rounded box (for standalone rows); "flat"
// renders as a divider-separated row (for rows already stacked inside a
// Card/FormSection container).
export default function ListRow({
  leading,
  title,
  subtitle,
  trailing,
  onClick,
  variant = 'card',
  sx,
}) {
  const isCard = variant === 'card';

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        cursor: onClick ? 'pointer' : 'default',
        ...(isCard
          ? { border: '1px solid', borderColor: 'divider', borderRadius: radius.lg }
          : { borderBottom: '1px solid', borderColor: 'divider' }),
        ...(onClick && { '&:active': { bgcolor: 'action.hover' } }),
        ...sx,
      }}
    >
      {leading && (
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{leading}</Box>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body1" noWrap>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" component="div">
            {subtitle}
          </Typography>
        )}
      </Box>
      {trailing && (
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{trailing}</Box>
      )}
    </Box>
  );
}
